import { useNavigate, useSearchParams } from "react-router-dom";
import LawnetLogo from "../../../assets/images/LAWNET LOGO.png";
import successGif from "../../../assets/images/paymentSuccess.gif";
import failedGif from "../../../assets/images/paymentFailed.gif";
const InvoiceResponse = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  return (
    <div className="payment-body">
      <div className="payment-container" >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img height={60} src={LawnetLogo} alt="" />
        </div>
        <div className={`message-box  "success" `}>
            <img src={successGif} alt="Success" className="gif" />
            <h2>Thank you for downloading the invoice.</h2>
            <h3>Please log in to the website to upload your payment proof (Bank transfer receipt or Payment confirmation slip).</h3>
            <h3>Existing and expired subscribers are required to contact us via email for further action.</h3>
            <button
              onClick={() => {
                  navigate("/login");
              }}
              className="login-button"
              >
              Login
            </button>
            <br/>
            <br/>
            <p className="h4">If you encounter any issues, kindly contact us via Call or WhatsApp at <b>014-3737188</b> or email us at <b>lawnet@printnasional.com.my</b></p>            
        </div>
      </div>
    </div>
  );
};

export default InvoiceResponse;
